module.exports = __webpack_public_path__ + "static/template_options_list-ed29e2df2f3fa5692af24890248604a3.png";